module.exports = __webpack_public_path__ + "static/img/frame-window_256.93f9077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frame-window_256.png
// module id = 5Hf8
// module chunks = 0